/**
 * Compares two message objects to determine if any UI-relevant fields have changed.
 * This performs an efficient shallow comparison of all fields that affect display.
 * 
 * @param {Object} oldMsg - The previous message state
 * @param {Object} newMsg - The new message state
 * @returns {boolean} true if messages differ, false if identical
 */
export const hasMessageChanged = (oldMsg, newMsg) => {
    if (!oldMsg || !newMsg) return oldMsg !== newMsg;

    // Compare all fields that affect UI display in MessageDetails
    return (
        oldMsg.id !== newMsg.id ||
        oldMsg.content !== newMsg.content ||
        oldMsg.sender_type !== newMsg.sender_type ||
        oldMsg.sent_at !== newMsg.sent_at ||
        // Status fields
        oldMsg.status?.delivered !== newMsg.status?.delivered ||
        oldMsg.status?.read !== newMsg.status?.read ||
        oldMsg.status?.failed !== newMsg.status?.failed ||
        oldMsg.status?.delivered_at !== newMsg.status?.delivered_at ||
        oldMsg.status?.read_at !== newMsg.status?.read_at ||
        // Critical message flags
        oldMsg.requires_escalation !== newMsg.requires_escalation ||
        oldMsg.is_abuse !== newMsg.is_abuse ||
        // Error information
        oldMsg.error_type !== newMsg.error_type ||
        oldMsg.error_details !== newMsg.error_details ||
        // Agent analysis
        oldMsg.agent_analysis !== newMsg.agent_analysis ||
        // Abuse info
        oldMsg.abuse_info !== newMsg.abuse_info ||
        // Transaction info
        JSON.stringify(oldMsg.transaction_info) !== JSON.stringify(newMsg.transaction_info) ||
        // Escalation data
        JSON.stringify(oldMsg.escalation) !== JSON.stringify(newMsg.escalation) ||
        // Media array
        JSON.stringify(oldMsg.medias) !== JSON.stringify(newMsg.medias) ||
        // Reactions array
        JSON.stringify(oldMsg.reactions) !== JSON.stringify(newMsg.reactions) ||
        // Edit history
        JSON.stringify(oldMsg.edit_history) !== JSON.stringify(newMsg.edit_history) ||
        // Reply to message
        JSON.stringify(oldMsg.reply_to) !== JSON.stringify(newMsg.reply_to)
    );
};
